// Modules
import cn from 'classnames';

// Types
import type { TAlertProps } from './Alert.type';

// Styles
import styles from './styles.module.scss';

// Constants
import { ALERT_COLORS, ALERT_DEFAULT_PROPS, DEFAULT_ICON } from './Alert.constant';

const Alert = (props: TAlertProps) => {
	const {
		className,
		color = ALERT_DEFAULT_PROPS.color,
		description,
		descriptionClassName,
		leftIcon,
		leftIconClassName,
		noLeftIcon,
		rightIcon,
		rightIconClassName,
		title,
		titleClassName,
		...restProps
	} = props;
	const DefaultIcon = ALERT_COLORS.includes(color!) ? DEFAULT_ICON[color!] : DEFAULT_ICON.information;

	const alertCN = cn(styles.legion_alert, className, styles[color!], {
		[styles.has_right_icon]: !!rightIcon,
		[styles.no_title]: !title,
	})
	const descriptionCN = cn(styles.description, descriptionClassName);
	const titleCN = cn(styles.title, titleClassName);
	const leftIconCN = cn(styles.left_icon, leftIconClassName);
	const rightIconCN = cn(styles.right_icon, rightIconClassName);

	return (
		<div className={alertCN} {...restProps}>
			{!noLeftIcon && (
				<span className={leftIconCN}>
					{leftIcon ? leftIcon : <i className={styles.default_icon}>{DefaultIcon}</i>}
				</span>
			)}
			<div className={styles.alert_content}>
				{title && <p className={titleCN}>{title}</p>}
				{description && <p className={descriptionCN}>{description}</p>}
			</div>
			{rightIcon && (
				<span className={rightIconCN}>
					{rightIcon}
				</span>
			)}
		</div>
	)
}

export default Alert;
